
// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable, of, tap } from 'rxjs';
import { AccessControlService } from '../services/access-control.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {
  constructor(private accessControlService: AccessControlService, private route: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const routePermission = route && route.data && route.data.permission ? route.data.permission : null;
    if ( routePermission == null ) {
        return of(true);
    }

    return this.accessControlService.isUserPermitted(routePermission).pipe(tap(isAllowed=> {
       if(!isAllowed){
        this.route.navigate(['/private/home']);
       }}
       ));
  }
}
